import { render, staticRenderFns } from "./RepresentativeList.vue?vue&type=template&id=4dbd5968&scoped=true&"
import script from "./RepresentativeList.vue?vue&type=script&lang=js&"
export * from "./RepresentativeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd5968",
  null
  
)

export default component.exports